export class SubCompanyLoanCountApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  // DEV-4923 SubCompany header "Active Loans" field. Loans-service read: count of
  // non-archived loans attributed to the sub-company (Application.SubCompanyId).
  // Company is resolved server-side from the JWT; returns { count }.
  async getActiveLoanCount({ subCompanyId }) {
    return this.#http.get(`/api/sub-companies/${subCompanyId}/active-loans-count`);
  }
}
